import {Component, OnInit, ViewChild} from '@angular/core';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {NgForm} from '@angular/forms';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';

@Component({
  selector: 'app-clinic-register-clinic',
  templateUrl: './clinic-register-clinic.component.html',
  styleUrls: ['./clinic-register-clinic.component.scss'],
  animations: [fadeInAnimation]
})
export class ClinicRegisterClinicComponent implements OnInit {
  clinicName: string;
  folioPrefix: string;
  folioStart: number;
  loaderImage: boolean;
  fileSelected: File;
  url: string | ArrayBuffer;
  dragEnter: boolean;
  isValidate: boolean;
  @ViewChild('form') form: NgForm;

  constructor(
    public alertService: MessageAlertService,
    private utilityService: UtilitiesService
  ) { }

  /**
   * Inicializa las propiedades
   */
  ngOnInit(): void {
    this.clinicName = '';
    this.folioPrefix = '';
    this.folioStart = 1;
  }

  /**
   * Cuando se lanza el evento on focus out en el input
   * @param event evento
   */
  onFocusOut(event: any): void {
    if (this.clinicName !== '' && this.folioPrefix === '') {
      this.folioPrefix = this.clinicName.split(' ').reduce((current: string, next: string) => {
        return current += next.substr(0, 1);
      }, '').toUpperCase();
    }
  }

  /**
   * Cuando se selecciona un logo para la clínica.
   * @param files archivos
   */
  onSelectLogo(files: FileList): void {
    const fileInput = files.item(0);
    if (!fileInput) return;
    this.loaderImage = true;
    const reader = new FileReader();
    reader.onload = (evt: ProgressEvent<FileReader>) => {
      if (this.utilityService.validateExtensionImage(fileInput as File)) {
        setTimeout(() => {
          this.fileSelected = fileInput as File;
          this.url = evt.target.result;
          this.dragEnter = false;
          this.loaderImage = false;
        }, 500);
      }
    };
    reader.onerror = (event: ProgressEvent<FileReader>) => {
      const errMsg = 'El archivo no se puede leer: ' + event.target.error.code;
      this.alertService.createMessage('error', errMsg);
    };
    reader.readAsDataURL(fileInput);
  }


  /**
   * Cuando se arrastra un logo para la clínica en el elemento html.
   * @param ev evento
   */
  onDropLogo(ev: DragEvent): void {
    ev.preventDefault();
    if (ev.dataTransfer.files[0] && this.utilityService.validateExtensionImage(ev.dataTransfer.files[0])) {
      this.loaderImage = true;
      this.fileSelected = ev.dataTransfer.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.fileSelected);
      reader.onloadend = (event: ProgressEvent<FileReader>) => {
        setTimeout(() => {
          this.url = event.target?.result;
          this.dragEnter = false;
          this.loaderImage = false;
        }, 500);
      };
      reader.onerror = (evt: ProgressEvent<FileReader>) => {
        const errMsg = 'El archivo no se puede leer: ' + evt.target.error.code;
        this.alertService.createMessage('error', errMsg);
      };
    }
  }

  onDragEnter(): void {
    this.dragEnter = true;
  }

  onDragLeave(): void {
    this.dragEnter = false;
  }

  allowDrop(ev): void {
    ev.preventDefault();
  }

  /**
   * Marca los campos para validación.
   */
  validate(): void {
    // this.isValidate = true;
    this.form.control.markAllAsTouched();
    this.form.control.markAsDirty();
  }

  /**
   * Envia los datos del componente.
   */
  getValue(): {
    clinicName: string,
    logo: File,
  } {
    return {
      clinicName: this.clinicName,
      logo: this.fileSelected
    };
  }
}
